import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { H3_TITLE } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import SalesOrdersList from './SalesOrdersList';
import './style.scss';
/**
 *
 */
class PendingSalesOrders extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <div className="org-wrapper">
          <div className="ant-col-md-24">
            <SalesOrdersList />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({

});

PendingSalesOrders.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PendingSalesOrders));
